'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.required = required;
exports.emailAddress = emailAddress;
exports.isAsciiCompliant = isAsciiCompliant;
exports.phoneNumber = phoneNumber;
exports.postCode = postCode;
exports.vatNumber = vatNumber;
exports.companyNumber = companyNumber;
exports.password = password;
exports.deliveryAddressCompanyName = deliveryAddressCompanyName;
exports.compare = compare;
exports.greaterThan = greaterThan;
exports.default = validateModel;

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'Validation', 'Security');

function required(value) {
    if (!value) {
        return Resx.Validation.FieldIsRquired;
    }
}

function emailAddress(value) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(value)) {
        return Resx.Validation.InvalidEmailAddress;
    }
}

function isAsciiCompliant(value) {
    var re = /^[\u0000-\u007F]*$/;
    if (!re.test(value)) {
        return Resx.Validation.EmailContainsInvalidCharsOrAccent;
    }
}

function phoneNumber(value) {
    if (!value) return;
    var re = /^\s*(\+|0\s*0)\s*4\s*2\s*[01]\s*(\d\s*){9}$|^\s*(\+|0\s*0)\s*(?!4\s*2\s*[01])(\d\s*){10,15}$|^\s*(0\s*9)\s*(\d\s*){8}$|^\s*[1-9]\s*(\d\s*){8}$/;

    if (!re.test(value.replace(/\s+/g, ''))) {
        return Resx.Validation.InvalidPhoneNumber;
    }
}

function postCode(value) {
    var re = /^([0-9]{3}[ ]?[0-9]{2})?$/;
    if (!re.test(value)) {
        return Resx.Validation.ZipCodeFormatErrorMessage;
    }
}

function vatNumber(value) {
    var re = /^([A-Z]{2}([0-9A-Z]\s?){4,12})?$/;
    if (value && !re.test(value.toUpperCase())) {
        return Resx.Validation.InvalidVatNumber;
    }
}
function companyNumber(value) {
    var re = /^([0-9]\s){0,20}$/;
    if (!re.test(value)) {
        return Resx.Validation.InvalidVatNumber;
    }
}

function password(value) {
    if (value && value.length < 8) {
        return Resx.Security.WeakPassword;
    }
}

function deliveryAddressCompanyName(value) {
    if (value && value.length > 40) {
        return Resx.Validation.DeliveryAddressCompanyNameLength;
    }
}

function compare(fieldName) {
    return function (value, model) {
        var otherValue = (0, _get3.default)(model, fieldName);
        if (value !== otherValue) {
            return Resx.Validation.PasswordsMustMatch;
        }
    };
}

function greaterThan(fieldName, validationMessage) {
    return function (value, model, root) {
        var otherValue = (0, _get3.default)(root, fieldName);
        if (value <= otherValue) {
            return validationMessage;
        }
    };
}

function validateModel(model, validationRules) {
    var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : model;

    var errors = {};
    (0, _forOwn2.default)(validationRules, function (rules, field) {
        var value = (0, _get3.default)(model, field);
        if (!(0, _isArray2.default)(rules)) {
            // complex type validation rules
            // validation sub-object
            var subErrors = validateModel(value, rules, root || model);
            if ((0, _keys2.default)(subErrors).length > 0) {
                (0, _set3.default)(errors, field, subErrors);
            }
        } else {
            // just find and use first error for field
            var fieldError = rules.map(function (rule) {
                return rule(value, model, root);
            }).filter(function (x) {
                return x;
            })[0];
            fieldError && (0, _set3.default)(errors, field, fieldError);
        }
    });
    return errors;
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/validation.js
// module id = 417
// module chunks = 0 1 2